<template>
  <div>
    <div style="width: 1300px; margin: 20px auto;">
      <el-card shadow="always" style="border-radius: 16px; border: none; padding: 10px 20px;">
        <!-- <div class="leftBox">
          <div class="innerBox">
            <div class="aboutUs">
              <div class="title_about_us" @click="goTo('AboutUs')">About us</div>
            </div>
            <div class="contactUs">
              <div class="title_contact_us"  @click="goTo('ContactUs')">Contact us</div>
            </div>
          </div>
        </div> -->
        <div class="rightBox" style="margin: 0 auto; width: 100%;">
          <div class="text">
            <h3>Plant Mitochondrial Genome Database (PMGD)</h3>
            Mitochondria, as a significant semi-autonomous organelle within
            eukaryotic cells, play a pivotal role in the study of plant
            phylogenetics and the exploration of biological evolutionary patterns.
            Despite the structural complexity of plant mitochondrial genomes,
            which far exceeds that of chloroplast genomes, presenting significant
            challenges in assembly and research, recent advancements in sequencing
            technologies and assembly algorithms have enabled the successful
            assembly and annotation of multiple plant mitochondrial genomes. These
            genomes, as vital carriers of genetic information, are crucial for
            unveiling the phylogenetic and evolutionary history of plants. To
            address the complexities and assembly difficulties associated with
            mitochondrial genomes, we have constructed a comprehensive multi-omics
            database, the Plant Mitochondrial Genome Database (PMGD), designed to
            provide researchers in the field of plant mitochondrial genomics with
            a convenient and comprehensive data resource platform. The PMGD
            integrates mitochondrial genome data from various plant lineages,
            including detailed gene annotations, taxonomic information,
            re-analyses of transcriptome datasets, and relevant research papers
            published over the past three years. We believe that the PMGD will
            significantly advance research in plant mitochondrial genomics and
            provide valuable resources for the botanical research community.
          </div>
          <div class="text">
            <h3>Comments and suggestions are welcomed!</h3>
              <div class="contact-person">
                  <span>PMGD:</span> njfu_pmgd@163.com
              </div>
              <span>Discussion Group (QQ): </span> 545434667
              <br>
              <span>Address:</span> Nanjing Forestry University, Nanjing 210037, China
              <div style="text-align: right; margin-top: 20px;">
                <a href="/example_data/Documentation.pdf" download="Documentation.pdf" style="color: #409EFF; text-decoration: none; font-weight: bold; font-size: 16px;">
                  Download documentation <i class="el-icon-download"></i>
                </a>
              </div>
          </div>
        </div>
      </el-card>
    </div>

    </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "AboutUs",
  components: {  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goTo(str) {
      this.$router.push({ name: str });
    },
  },
};
</script>
<style scoped>
.text span.number {
  font-weight: bold; /* Make numbers bold */
  color: #007bff; /* A distinct blue color for numbers */
  font-size: 1.2em; /* Slightly larger size for numbers */
  background-color: #f0f0f0; /* A light gray background for numbers */
  padding: 2px 4px; /* Padding around the numbers */
  border-radius: 4px; /* Rounded corners for the background */
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
}
.text {
  padding: 25px 0;
  font-weight: 500;
  font-family: "Times New Roman", Times, serif;
  color: #333; /* Dark gray color for the text */
  line-height: 2; /* Spacing between lines */
  font-size: 16px; /* Base font size */
  max-width: 1200px; /* Maximum width of the text container */
  margin: 0 auto; /* Center the text container */
}
/* .leftBox {
  width: 310px;
  border-right: 1px solid #b8b8b8;
} */
.rightBox {
  width: 1200px;
}
.innerBox {
  width: 250px;
  height: 150px;
  margin: 50px 0 0 50px;
}

.aboutUs {
  height: 40px;
  background-color: rgb(203, 225, 203);
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  padding-top: 13px;
  border: 1px solid #b8b8b8;
}
.aboutUs:hover {
  background-color: rgb(203, 225, 203);
}
.title_about_us {
  text-align: center;
  font-size: 20px;
}
.contactUs {
  height: 40px;
  background-color: white;
  border-radius: 0 0 10px 10px;
  cursor: pointer;
  border: 1px solid #b8b8b8;
  padding-top: 13px;
}
.contactUs:hover {
  background-color: rgb(203, 225, 203);
  transition: 0.3s;
}
.title_contact_us {
  text-align: center;
  font-size: 20px;
}
strong {
  display: inline-block;
  width: 90px;
  font-size: 14px;
  font-weight: 6000;
}
span {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
}
</style>